import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
  useTheme
} from '@mui/material';
import { AttachFile, FolderOpen } from '@mui/icons-material';

function FileAttachmentList({
  allFiles,
  selectedFiles,
  toggleFileSelection,
  displayedFiles,
  searchQuery
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (allFiles.length === 0) return null;

  return (
    <Box sx={{ mb: 1, flexShrink: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
        <FolderOpen sx={{ fontSize: 14, color: '#667eea' }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            fontSize: '0.75rem',
            color: 'text.primary',
          }}
        >
          Context Files
        </Typography>
        <Chip
          label={`${selectedFiles.length} selected`}
          size="small"
          sx={{
            height: 16,
            fontSize: '0.65rem',
            bgcolor: selectedFiles.length > 0 ? 'rgba(102, 126, 234, 0.15)' : (isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'),
            color: selectedFiles.length > 0 ? '#667eea' : 'text.secondary',
            fontWeight: 500,
            '& .MuiChip-label': {
              px: 0.75,
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.5,
          maxHeight: 90,
          overflowY: 'auto',
          p: 1,
          borderRadius: 1.5,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          '&::-webkit-scrollbar': {
            width: '3px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(102, 126, 234, 0.3)',
            borderRadius: '2px',
          },
        }}
      >
        {displayedFiles.map((file) => {
          const isSelected = selectedFiles.includes(file.file_id);
          return (
            <Chip
              key={file.file_id}
              icon={<AttachFile sx={{ fontSize: 12 }} />}
              label={file.file_name}
              size="small"
              onClick={() => toggleFileSelection(file.file_id)}
              clickable
              sx={{
                height: 22,
                borderRadius: 1,
                fontSize: '0.7rem',
                transition: 'all 0.2s ease',
                bgcolor: isSelected ? 'rgba(102, 126, 234, 0.15)' : 'transparent',
                borderColor: isSelected ? '#667eea' : 'divider',
                color: isSelected ? '#667eea' : 'text.primary',
                fontWeight: isSelected ? 500 : 400,
                '& .MuiChip-icon': {
                  color: isSelected ? '#667eea' : 'text.secondary',
                },
                '&:hover': {
                  bgcolor: isSelected ? 'rgba(102, 126, 234, 0.25)' : (isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)'),
                  borderColor: '#667eea',
                },
              }}
              variant="outlined"
            />
          );
        })}
        {displayedFiles.length === 0 && searchQuery && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', fontStyle: 'italic' }}>
            No matching files found.
          </Typography>
        )}
        {displayedFiles.length === 0 && !searchQuery && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', fontStyle: 'italic' }}>
            No files available.
          </Typography>
        )}
      </Box>

      <Divider sx={{ mt: 1, mb: 1, borderColor: isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)' }} />
    </Box>
  );
}

export default FileAttachmentList;
